import module from '../module';
import * as _ from 'lodash';
import CommonConstants from "../../../utils/CommonConstants";

export class CartGroupsService {
    static $inject = [ 'Session', 'ConfigurationService' ];

    constructor(sessionService, configurationService) {
        this._sessionService = sessionService;
        this._configurationService = configurationService;
    }

    async groupItems(items, participants) {

        const email = await this._sessionService.getUserEmail();
        const loggedIn = await this._sessionService.loggedIn();
        let owner = participants.find(p => p.status === 'OWNER');
        let isCartOwner = false;
        if (owner) {
            isCartOwner = email === owner.email;
        }

        const retailer = await this._configurationService.getItem('retailer');

        return _.chain(items)
                .groupBy(item => { return item.participantEmail; })
                .values()
                .map(items => {
                    const participantEmail = items[ 0 ].participant ? items[ 0 ].participant.participantEmail : items[ 0 ].participantEmail;
                    const myTab = !loggedIn || (items.length > 0 && participantEmail && participantEmail === email);
                    const participant = !loggedIn || participants.find(p => p.email === participantEmail);
                    const participantName = participant ? (loggedIn ? (participant.name || participant.email || participant.participantEmail || "?") : 'Me') : participantEmail;
                    return {
                        participant: participant,
                        iconLetter: participantName[ 0 ],
                        participantName: participantName,
                        items: items,
                        subtotal: _.sumBy(items, (item) => {
                            return item.price * item.quantity;
                        }),
                        paid: (participant.paymentStatus !== 0),
                        editable: myTab || (isCartOwner && retailer.cartonomyMode !== CommonConstants.CartonomyMode.marketing),
                        myTab: myTab,
                        collapsed: true
                    };
                })
                .sortBy(g => (g.myTab ? 'a' : 'b') + ':' + g.participantName)
                .value();
    }
}

module.service('CartGroupsService', CartGroupsService);



// WEBPACK FOOTER //
// ./src/modules/cart/services/CartGroupsService.js